import { Divider } from '@mui/material'
import React from 'react'
import { BiPencil } from 'react-icons/bi'
import { LinkData } from '../../Pages/CobrancaCriar/interfaces'
import { frequenciaCobranca } from '../../utils/frequenciaCobranca'
import {
    BillingValue,
    Edit,
    InfoAndEdit,
    InfoAndEdit2,
    InfoPayment,
    ReceiverValue,
    SummarySection,
} from './styles'

interface Props {
    setActiveStep(step: number): void
    getBillingCommission(valueBilling: number): number
    linkData: LinkData
}

export default function Step3({
    setActiveStep,
    getBillingCommission,
    linkData,
}: Props) {
    function howTheCustomerWillPay() {
        if (linkData.tipoLink === 0 && Number(linkData.quantParcelas) === 1) {
            return (
                <>
                    <h4>Como seu cliente irá pagar</h4>
                    <h5>À vista</h5>
                </>
            )
        }

        if (linkData.tipoLink === 0 && Number(linkData.quantParcelas) > 1) {
            return (
                <>
                    {/* <h4>Como seu cliente irá pagar</h4> */}
                    <h5>Parcelado</h5>
                    <h4>Número máximo de parcelas</h4>
                    <h5>Em até {linkData.quantParcelas} parcelas</h5>
                </>
            )
        }

        if (linkData.tipoLink === 1) {
            return (
                <>
                    {/* <h4>Como seu cliente irá pagar</h4> */}
                    <h5>Recorrência</h5>
                    <h4>Frequência da cobrança</h4>
                    <h5>
                        {
                            frequenciaCobranca[
                                linkData.frequenciaCobranca as keyof typeof frequenciaCobranca
                            ]
                        }
                    </h5>
                </>
            )
        }
    }

    const commissionValue = getBillingCommission(Number(linkData.valor))
    const rest = (Number(linkData.valor) - commissionValue).toFixed(2)

    return (
        <>
            <SummarySection>
                <h2 className="title">
                    Confira seus dados para finalizar a cobrança
                </h2>

                <InfoPayment>
                    <InfoAndEdit>
                        <h2>Informações da Cobrança</h2>
                        <Edit onClick={() => setActiveStep(0)}>
                            <BiPencil size={16} color="#0030B9" />
                            <span>Editar</span>
                        </Edit>
                    </InfoAndEdit>

                    <h4>Valor da Cobrança</h4>
                    <h5>
                        {Number(linkData.valor).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </h5>

                    <h4>Nome da Cobrança</h4>
                    <h5>{linkData.nomeLink}</h5>

                    <InfoAndEdit2>
                        <h2>Forma de Pagamento</h2>
                        <Edit onClick={() => setActiveStep(1)}>
                            <BiPencil size={16} color="#0030B9" />
                            <span>Editar</span>
                        </Edit>
                    </InfoAndEdit2>

                    {howTheCustomerWillPay()}

                    <BillingValue>
                        {/* <div>
                            <h4>Valor da Cobrança</h4>
                            <h5>{Number(linkData.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h5>
                        </div> */}
                        <div>
                            <h4>Valor do serviço Tree</h4>
                            <h5>
                                {Number(commissionValue).toLocaleString(
                                    'pt-br',
                                    { style: 'currency', currency: 'BRL' }
                                )}
                            </h5>
                        </div>
                    </BillingValue>

                    {/* <BillingValue>
                        <div>
                            <h4>Valor da comissão</h4>
                            <h5>- {Number(commissionValue).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h5>
                        </div>
                    </BillingValue> */}

                    <Divider style={{ marginTop: 10, marginBottom: 10 }} />

                    <ReceiverValue>
                        <h4>Valor líquido a receber</h4>
                        <h3>
                            {Number(rest).toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </h3>
                    </ReceiverValue>
                </InfoPayment>
            </SummarySection>
        </>
    )
}
